import * as Effects from "redux-saga/effects";
import { ProjectActions } from "../reducers/project/actionsNames";
import { getCartId, getForm } from "../reducers/project/selectors";

function* fetchContent(action) {
    const cartId = yield Effects.select(getCartId);
    const form = yield Effects.select(getForm);

    const response = yield fetch(process.env.REACT_APP_API_URL + "/order/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
            cart: cartId,
            email: form.email,
            name: form.name,
            fast: form.fastOrder,
            phone: form.phone,
            notes: form.notes,
        }),
    });

    let order = yield response.json();

    yield Effects.put({
        type: ProjectActions.InsertOrder,
        order: order,
    });
}

export default function* () {
    yield Effects.takeLatest(ProjectActions.CreateOrder, fetchContent);
}
